module.exports = __webpack_public_path__ + "05_medium_gold.52c8d6a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_medium_gold.png
// module id = xW9M
// module chunks = 0